import type { UploadStatus } from '@/features/knowledge-bases/model';
import { i18n } from '@/shared/i18n';

/** v4 Badge variant for an in-progress upload's status chip. */
export type UploadStatusBadgeVariant =
  | 'default'
  | 'secondary'
  | 'positive'
  | 'destructive'
  | 'warning';

export const getStatusBadgeVariant = (status: UploadStatus): UploadStatusBadgeVariant => {
  switch (status) {
    case 'pending':
      return 'secondary';
    case 'uploading':
      return 'default';
    case 'completed':
      return 'positive';
    case 'failed':
      return 'destructive';
    case 'skipped':
      return 'warning';
    default:
      return 'secondary';
  }
};

export const getStatusLabel = (status: UploadStatus): string => {
  switch (status) {
    case 'pending':
      return i18n.t('knowledge:knowledgeBases.knowledgeBaseDocumentsTable.status.pending');
    case 'uploading':
      return i18n.t('knowledge:knowledgeBases.knowledgeBaseDocumentsTable.status.uploading');
    case 'completed':
      return i18n.t('knowledge:knowledgeBases.knowledgeBaseDocumentsTable.status.completed');
    case 'failed':
      return i18n.t('knowledge:knowledgeBases.knowledgeBaseDocumentsTable.status.failed');
    case 'skipped':
      return i18n.t('knowledge:knowledgeBases.knowledgeBaseDocumentsTable.status.skipped');
    default:
      return status;
  }
};
